import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationStatus } from '../../models/application/application-status.interface';
import { withCache } from '@ngneat/cashew';
import { constants } from '@edassist/common';

@Injectable({
	providedIn: 'root'
})
export class ClientAdminService {
	private readonly relativeUrl = 'client-admins/';

	constructor(private readonly http: HttpClient) {}

	getAllActiveApplicationStatus(isApplicationSearch: boolean = false): Observable<Array<ApplicationStatus>> {
		return this.http.get<Array<ApplicationStatus>>(
			`${this.relativeUrl}application-status-dropdown?isApplicationSearch=${isApplicationSearch}`,
			{
				context: withCache({
					version: constants.LOCAL_STORAGE.API_CACHE.VERSION_V1,
					key: 'getAllActiveApplicationStatus'
				})
			}
		);
	}
}
